import React from 'react';
import { Box, Flex } from '../Rebass';
import Text from '../Text';
import styled from '@emotion/styled';
import theme from '../../theme';
import { AuthorProps } from '.';

const StyledAuthor = styled(Flex)`
  border-top: 1px solid ${theme.colors.baseGrayVeryLight};
`;

const AuthorSimple = ({ name, role, image }: AuthorProps) => {
  return (
    <StyledAuthor alignItems="center" pt={[3]} mt={[3]}>
      {image && <Box mr={[2]}>{image}</Box>}
      <Flex flexDirection="column" flex="2 1 auto">
        <Box mb={[1]}>
          <Text size="small" fontWeight="bold">
            By {name}
          </Text>
        </Box>
        <Box>
          <Text size="small">{role}</Text>
        </Box>
      </Flex>
    </StyledAuthor>
  );
};

export default AuthorSimple;
